export default {"src":"/_next/static/media/pattern.c9f5564a.svg","height":1,"width":2};